import { useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { TIMER_DELAY } from './useReturnUrl.constants';
import { UseReturnUrlReturn } from './useReturnUrl.types';
import {
  parseAndValidateUrl,
  canStoreAsReturnUrl,
  getFullUrlPath,
  storeReturnUrl,
  clearReturnUrlData,
  handleReturnUrlNavigation,
} from './functions';

const useReturnUrl = (): UseReturnUrlReturn => {
  const navigate = useNavigate();

  const isNavigatingRef = useRef(false);

  const setReturnUrl = useCallback((url: string) => {
    const urlObj = parseAndValidateUrl(url, window.location.origin);

    if (!urlObj) return;

    const { pathname } = urlObj;

    if (canStoreAsReturnUrl(pathname)) {
      const fullUrl = getFullUrlPath(urlObj);
      storeReturnUrl(fullUrl);
    }
  }, []);

  const navigateToReturnUrl = useCallback(() => {
    if (isNavigatingRef.current) return;

    isNavigatingRef.current = true;

    try {
      handleReturnUrlNavigation(navigate);
    } finally {
      setTimeout(() => {
        isNavigatingRef.current = false;
      }, TIMER_DELAY);
    }
  }, [navigate]);

  const clearReturnUrl = useCallback(() => {
    clearReturnUrlData();
  }, []);

  return {
    setReturnUrl,
    navigateToReturnUrl,
    clearReturnUrl,
  };
};

export default useReturnUrl;
